export const COMPANY_ADMIN = 'companyAdmin';
export const SHOP_ADMIN = 'shopAdmin';
